import { useSignal } from '@preact/signals-react'
import { capitalize } from '@mui/material'
import { postSubmit } from '@ui-seeker/utils'
import { reportFormData, reportFormErrors, reportFormNumSearches } from 'Pages/ReportsAlerts/Reports/@signals'
import { useValidatorSeeker } from '@ui-seeker/app'
import { useCallback, useEffect } from 'react'
import { NUM_SEARCHES_FIELDS } from 'Pages/ReportsAlerts/Reports/@constants'
import { useReportBackendApiPath } from 'Pages/ReportsAlerts/Reports/@hooks/index'

export default function useReportFormInfo(value, key, validation) {

	const dataInfo = useSignal(value)
	const { backendUrl } = useReportBackendApiPath()


	const setDataInfo = useCallback((value, allowRequest = true) => {
		dataInfo.value = value
		const updatedReportFormFieldData = reportFormData.peek()
		updatedReportFormFieldData[key] = value

		reportFormData.value = { ...updatedReportFormFieldData }
		requestNumSearches(allowRequest)
	}, [])

	const requestNumSearches = useCallback(allowRequest => {
		if (NUM_SEARCHES_FIELDS.includes(key) && allowRequest) {
			postSubmit(`${backendUrl}/num-searches`, reportFormData.value)
				.then(({ numSearches }) => reportFormNumSearches.value = numSearches)
				.catch(() => {})
		}
	}, [key])

	const {
		isValid,
		errors,
	} = useValidatorSeeker({ [key]: dataInfo.value }, validation)

	useEffect(() => {
		reportFormErrors.value = { ...reportFormErrors.value, [key]: isValid }
		return () => {
			reportFormErrors.value = { ...reportFormErrors.value, [key]: true }
		}
	}, [isValid])


	return {
		[key]: dataInfo.value,
		[`set${capitalize(key)}Info`]: setDataInfo,
		error: errors[key],
	}
}
